module.exports = __webpack_public_path__ + "static/illustrazione-capitolo-3-fb44294f779b9360edc74f8044387379.svg";